module.exports = __webpack_public_path__ + "assets/img/chihuang50_3.01dc47fb.jpg";